var _rect, _g, _line, _line2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrangeList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#E2E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 75,
    width: 169,
    height: 150,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 75.5,
    width: 168,
    height: 149,
    rx: 3.5,
    stroke: "black"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 125.5,
    x2: 235,
    y2: 125.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 174.5,
    x2: 235,
    y2: 174.5,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 87,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#CE8799"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 106,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#87C6D4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 137,
    width: 38,
    height: 13,
    rx: 6.5,
    fill: "#CE8799"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 156,
    width: 35,
    height: 8,
    rx: 4,
    fill: "#87C6D4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 186,
    width: 21,
    height: 13,
    rx: 6.5,
    fill: "#CE8799"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 205,
    width: 27,
    height: 8,
    rx: 4,
    fill: "#87C6D4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 88.5,
    width: 21,
    height: 10,
    rx: 5,
    stroke: "#B2C98D",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 138.5,
    width: 39,
    height: 10,
    rx: 5,
    stroke: "#B2C98D",
    strokeWidth: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 187.5,
    width: 35,
    height: 10,
    rx: 5,
    stroke: "#B2C98D",
    strokeWidth: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 95,
    width: 42,
    height: 13,
    rx: 6.5,
    fill: "#F5BF33"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 144,
    width: 24,
    height: 13,
    rx: 6.5,
    fill: "#F5BF33"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 193,
    width: 35,
    height: 13,
    rx: 6.5,
    fill: "#F5BF33"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 66,
    y: 75,
    width: 173,
    height: 154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrangeList);
export default __webpack_public_path__ + "static/media/arrange-list.9f28df0e0b0c48eb4cbc5817462410c2.svg";
export { ForwardRef as ReactComponent };